/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface AppConfigRequest {

    features?: string[];

    /**
     * The app's current settings
     */
    settings?: { [key : string]: any };

    /**
     * Is the site in maintenance mode
     */
    maintenance?: boolean;

    /**
     * Is an app update available
     */
    prompt_update?: boolean;

    /**
     * Is a highly recommeded app update available
     */
    annoying_prompt_update?: boolean;

    /**
     * Is an app update mandatory
     */
    force_update?: boolean;

    /**
     * What is the maintenance message to show
     */
    blocker_message?: string;

    /**
     * Link to web page with app information
     */
    app_info_url?: string;

    /**
     * Link to the mobile app in IOS or Google stores
     */
    native_store_url?: string;

}

@Model('AppConfig')
export class ApiAppConfig extends BaseModel implements AppConfigRequest {

    
    
    features: string[];

    /**
     * The app's current settings
     */
    
    
    settings: { [key : string]: any };

    /**
     * Is the site in maintenance mode
     */
    
    
    maintenance: boolean;

    /**
     * Is an app update available
     */
    
    
    prompt_update: boolean;

    /**
     * Is a highly recommeded app update available
     */
    
    
    annoying_prompt_update: boolean;

    /**
     * Is an app update mandatory
     */
    
    
    force_update: boolean;

    /**
     * What is the maintenance message to show
     */
    
    
    blocker_message: string;

    /**
     * Link to web page with app information
     */
    
    
    app_info_url: string;

    /**
     * Link to the mobile app in IOS or Google stores
     */
    
    
    native_store_url: string;

}
